<!-- <dx-popup [width]="width" [height]="height" [visible]="popupVisible" [hideOnOutsideClick]="hideOnOutsideClick"
  (visibleChange)="onPopupVisibleChange($event)" [showCloseButton]="true" [title]="title">
  <div *dxTemplate="let data of 'content'">
    <ng-container *ngIf="contentTemplate">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </ng-container>
  </div>

  <dxi-popup-toolbar-item widget="dxButton" toolbar="bottom" location="center" *ngIf="toolbarButtonOptions"
    [options]="mergedToolbarOptions"></dxi-popup-toolbar-item>
</dx-popup> -->


<div class="modal" *ngIf="isModalOpen">
  <div class="modal-content">
    <div class="modal-header">
      <h2>{{ title }}</h2>
      <span class="modal-close" (click)="closeModal()">
        <img src="./assets/icons/cross.png" alt="close" />
      </span>
    </div>

    <div class="modal-body">
      <ng-container *ngIf="contentTemplate">
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </ng-container>
    </div>
  </div>
</div>